// MOCK: this is mocked only for prototyping purposes
// This should be replaced with a solid guarding strategy that will
// include permission check for each route
const setupMockedAuthGuard = router => {
	router.beforeEach((to, from, next) => {
		// HACK: form forms remote, no need for token for demo
		if (to.name !== "ViewAuthLogin" && !window.localStorage[process.env.VUE_APP_TOKEN_KEY]) {
			next({ name: "ViewAuthLogin" })
			return
		}
		next()
	})
}

export { setupMockedAuthGuard }
